import { useEffect, useState } from 'react';
import { useLang } from '../i18n';
import { API } from '../utils/operations';
import { Reveal } from './Reveal';
import { MarketplaceCard } from './MarketplaceCard';

export const PublicPartnerProducts = ({ type, island }) => {
  const { t } = useLang();
  const [products, setProducts] = useState([]);

  useEffect(() => {
    const params = new URLSearchParams({ type });
    if (island && island !== 'Todos') params.set('island', island);
    fetch(`${API}/products?${params}`)
      .then((r) => (r.ok ? r.json() : []))
      .then((d) => setProducts(Array.isArray(d) ? d : []))
      .catch(() => setProducts([]));
  }, [type, island]);

  if (products.length === 0) return null;

  return (
    <section className="mt-14 border-t border-eco-ink/10 pt-12" data-testid={`public-partner-products-${type}`}>
      <Reveal>
        <p className="eco-eyebrow">{t('partners.kicker')}</p>
        <h2 className="mt-3 font-serif text-2xl font-semibold text-eco-ink md:text-3xl">{t('ppp.title')}</h2>
        <p className="mt-2 max-w-2xl text-sm text-eco-ink/55">{t('ppp.sub')}</p>
      </Reveal>
      <div className="mt-8 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {products.map((p, i) => (
          <Reveal key={p.id} delay={(i % 3) * 0.08}>
            <MarketplaceCard
              to={`/partner-products/${p.id}`}
              testid={`partner-product-card-${p.id}`}
              image={p.images?.[0] ? `${process.env.REACT_APP_BACKEND_URL}${p.images[0]}` : ''}
              imageBadge={p.island}
              eyebrow={`${p.island} · ${p.type}`}
              title={p.name}
              location={p.location || p.island}
              duration={p.duration}
              partner={`${t('detail.operator')}: ${p.partner_name}`}
              cta={t('cta.availability')}
              priceLabel={p.price_public_eur !== null && p.price_public_eur !== undefined && ['fixed_price', 'from_price'].includes(p.pricing_mode) ? `${p.pricing_mode === 'from_price' ? `${t('pm.from')} ` : ''}${p.price_label}` : null}
              priceTestid={`partner-product-price-${p.id}`}
            />
          </Reveal>
        ))}
      </div>
    </section>
  );
};
